import { Spin, Form, Row, Col, Tooltip, Modal, } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { PbrCard } from 'src/components/common/PbrCard/PbrCard';
import { PricingResult } from 'src/components/common/pricing-result/PricingResult';
import { ShowNotification } from 'src/components/common/ShowNotification/ShowNotification';
import StandardButton from 'src/components/common/StandardButton/StandardButton';
import { BaseDateComponent } from 'src/components/PricingComponents/BaseDateComponent/BaseDateComponent';
import { CommissionComponent } from 'src/components/PricingComponents/CommissionComponent/CommissionComponent';
import { DisbursementDateComponent } from 'src/components/PricingComponents/DisbursementDateComponent/DisbursementDateComponent';
import { IssueDateComponent } from 'src/components/PricingComponents/IssueDateComponent/IssueDateComponent';
import { PriceSpreadComponent } from 'src/components/PricingComponents/PriceSpreadComponent/PriceSpreadComponent';
import { PSSComponent } from 'src/components/PricingComponents/PSSComponent/PSSComponent';
import { ReducedPercentLenderComponent } from 'src/components/PricingComponents/ReducedPercentLenderComponent/ReducedPercentLenderComponent';
import { CalculationRequestTypeEnum } from 'src/services/interfaces/calculator/CalculationRequestTypeEnum';
import { IPrecatorioCalculator } from 'src/services/interfaces/calculator/IPrecatorioCalculator';
import { IPricingCalculatorRequest } from 'src/services/interfaces/calculator/IPricingCalculatorRequest';
import { IPricingCalculatorResponse } from 'src/services/interfaces/calculator/IPricingCalculatorResponse';
import { IPricingParametersCalculator } from 'src/services/interfaces/calculator/IPricingParametersCalculator';
import { CostType } from "src/services/interfaces/calculator/CostType";
import { ServiceContext } from 'src/services/provider/Service.provider';
import { MapEmptyPricingRequest } from './MapEmptyPricingRequest';
import { SelectCourtAndCourtType } from 'src/components/common/SelectCourtTypeCourtCorrectionType/SelectCourtAndCourtType';
import { EmptyPrecatorioCalculatorRequest } from 'src/services/mapper/EmptyPrecatorioCalculatorRequest';
import { SelectNature } from 'src/components/common/SelectNature/SelectNature';
import { PrecatorioPrincipal } from 'src/components/PricingComponents/PrecatorioPrincipal/PrecatorioPrincipal';
import { PrecatorioInterest } from 'src/components/PricingComponents/PrecatorioInterest/PrecatorioInterest';



function ManualCalculatorPage(props: RouteComponentProps<any> & FormComponentProps) {
  const { pricingService } = useContext(ServiceContext);
  const [pricingRequest, setPricingRequest] = useState<IPricingCalculatorRequest>(MapEmptyPricingRequest(CalculationRequestTypeEnum.OfficerManual));

  const [loading, setLoading] = useState(false);
  const [pricingResponse, setPricingResponse] = useState<IPricingCalculatorResponse>(null);

  useEffect(() => {
    handlePriceRequest({ precatorio: EmptyPrecatorioCalculatorRequest })
  }, []);

  const clearFields = () => {
    setPricingRequest(MapEmptyPricingRequest(CalculationRequestTypeEnum.OfficerManual))
    props.form.setFieldsValue({
      type: "",
      ddlType: "",
      ddlCourt: "",
      ddlCorrectionType: "",
      inputPencentLender: "",
      baseDate: null,
      inputDataExpedicao: null,
      disbursementDate: null,
      principal: 0,
      interest: 0,
      price: 0,
      disbursementCost: 0,
      settlementCost: 0,
      spread: 0,
      commission: 0,
      cost: 0,
      costType: CostType.percentualCost,
    });
  };


  const handlePriceRequest = (value: Partial<IPricingCalculatorRequest>) => {
    setPricingRequest({ ...pricingRequest, ...value });
  }

  const handlePricingParametersRequest = (value: Partial<IPricingParametersCalculator>) => {
    setPricingRequest({ ...pricingRequest, pricingParameters: { ...pricingRequest.pricingParameters, ...value } });
  }

  const handlePricingPrecatorioRequest = (value: Partial<IPrecatorioCalculator>) => {
    setPricingRequest({ ...pricingRequest, precatorio: { ...pricingRequest.precatorio, ...value } });
  }

  function validateFields(e: React.FormEvent, callback: () => void) {
    e.preventDefault();

    props.form.validateFields(async (err) => {
      if (err) {
        return ShowNotification.Warn("Cálculo inválido", "Por favor, informe todos os dados obrigatórios.");
      }
      callback()
    })
  }

  function calculateManualPricing(e: React.FormEvent) {
    validateFields(e, async () => {
      setLoading(true);

      try {
        const resp = await pricingService.calculatePrice(pricingRequest);

        if (resp !== null) {
          setPricingResponse(resp.data);
          if (!resp.data.isRecalculateValid) {
            ShowNotification.Error("Não foi possivel realizar o cálculo", resp.data.message);
          }
          window.scrollTo(0, document.body.scrollHeight);
        }
      } catch (err) {
        ShowNotification.Error("Não foi possivel realizar o cálculo", err?.response?.data?.message ?? "Tente novamente")
      }

      setLoading(false)
    })

  }

  return (
    <PbrCard className="consult" title="Calculadora Manual" bordered={false} style={{ width: "100%" }}>
      <Spin spinning={loading}>
        <Form>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Row style={{ textAlign: "right", marginBottom: "15px" }}>
                <Tooltip title="Limpar dados do formulário" placement="topRight">
                  <button className="btn danger" onClick={() => { Modal.confirm({ title: "Deseja realmente limpar o formulário?", onOk: () => clearFields() }); }}>
                    Limpar dados
                    </button>
                </Tooltip>
              </Row>

              <Row gutter={32}>
                <SelectCourtAndCourtType
                  filledFields={false}
                  colLgSize={8}
                  colMdSize={8}
                  onChangeCourt={(id) => handlePricingPrecatorioRequest({ court: { ...pricingRequest.precatorio?.court, id }, })}
                  courtId={pricingRequest.precatorio?.court?.id}
                  onChangeCourtType={(id) => handlePricingPrecatorioRequest({ type: { ...pricingRequest.precatorio?.type, id } })}
                  courtTypeId={pricingRequest.precatorio?.type?.id}
                  showCorrectionType
                  isTypeRequired
                  isCourtRequired
                  form={props.form}
                />
              </Row>

              <Row gutter={32}>
                <Col xs={24} sm={24} md={8} lg={8}>
                  <ReducedPercentLenderComponent pricingParameters={pricingRequest.pricingParameters} onChange={handlePricingParametersRequest} form={props.form} />
                </Col>

                <Col xs={24} sm={24} md={8} lg={6}>
                  <PrecatorioPrincipal
                    onChange={(v) => handlePricingPrecatorioRequest({ principal: v })}
                    principal={pricingRequest.precatorio?.principal}
                    form={props.form}
                  />
                </Col>

                <Col xs={24} sm={24} md={8} lg={6}>
                  <PrecatorioInterest
                    onChange={(v) => handlePricingPrecatorioRequest({ interest: v })}
                    interest={pricingRequest.precatorio?.interest}
                    form={props.form}
                  />
                </Col>
                <Col xs={24} sm={24} md={8} lg={4}>
                  <SelectNature
                    value={pricingRequest.precatorio?.nature?.id}
                    onChange={e => handlePricingPrecatorioRequest({ nature: { ...pricingRequest.precatorio?.nature, ...e } })}
                    form={props.form}
                    isNatureRequired
                  />
                </Col>
              </Row>

              <Row gutter={32}>
                <Col xs={24} sm={24} md={8} lg={8}>
                  <PriceSpreadComponent
                    label="Calcular por preço ou spread?"
                    request={pricingRequest}
                    onChangePriceRequest={handlePriceRequest}
                    onChangePriceParametersRequest={handlePricingParametersRequest}
                    form={props.form}
                  />
                </Col>
                <Col xs={24} sm={24} md={8} lg={8}>
                  <CommissionComponent alignVertical={false} pricingParameters={pricingRequest.pricingParameters} price={pricingRequest.price} onChange={handlePricingParametersRequest} form={props.form} />
                </Col>
                <Col xs={24} sm={24} md={4} lg={4} style={{ marginTop: "15px" }}>
                  <PSSComponent
                    canEditPssPercentual={false}
                    canEditPssAbsolute
                    pss={pricingRequest.pricingParameters.pss}
                    pssabsolute={pricingRequest.pricingParameters.pssAbsolute}
                    isPss={pricingRequest.pricingParameters.isPss}
                    onChangePss={(pss) => handlePricingParametersRequest({ pss })}
                    onChangePssAbsolute={(pssAbsolute) => handlePricingParametersRequest({ pssAbsolute })}
                    onChangeIsPss={(isPss) => handlePricingParametersRequest({ isPss })}
                    form={props.form}
                    pssAbsoluteRequired={pricingRequest.pricingParameters.isPss && pricingRequest.precatorio.principal === 0}
                  />
                </Col>
              </Row>

              <Row gutter={32}>
                <Col xs={24} sm={24} md={8} lg={8}>
                  <BaseDateComponent request={pricingRequest.precatorio} onChange={handlePricingPrecatorioRequest} form={props.form} />
                </Col>

                <Col xs={24} sm={24} md={8} lg={8}>
                  <IssueDateComponent request={pricingRequest.precatorio} onChange={handlePricingPrecatorioRequest} form={props.form} />
                </Col>

                <Col xs={24} sm={24} md={8} lg={8}>
                  <DisbursementDateComponent pricingRequest={pricingRequest.pricingParameters} onChange={handlePricingParametersRequest} form={props.form} />
                </Col>
              </Row>

              <Row gutter={32}>
                <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: "center" }}>
                  <StandardButton loading={loading} htmlType="submit" onClick={e => calculateManualPricing(e)}>
                    Calcular
                  </StandardButton>
                </Col>
              </Row>
            </Col>
          </Row>
          {pricingResponse && <PricingResult title={"Resultado da Precificação"} result={pricingResponse} showAllData />}
        </Form >
      </Spin >

    </PbrCard >
  );
}

export default Form.create()(ManualCalculatorPage);






// WEBPACK FOOTER //
// ./src/pages/ferramentas/manual-calculation/ManualCalculation.tsx